import { useEffect } from 'react'
import { Flex, Modal, ModalBody, ModalContent, ModalHeader, ModalOverlay } from '@chakra-ui/react'
import { formatUnits } from 'viem'

import { DEFAULT_DECIMALS } from '~/constants'
import { useLabelsToggle } from '~/hooks/useLabelsToggle'
import { useTranslation } from '~/lib/i18n'
import { DeeprStakingI } from '~/types'
import LabelsToggle from '../common/LabelsToggle'
import CloseModalButton from './CloseModalButton'
import StakeForm from './StakeForm'
import StakeWithdrawForm from './StakeWithdrawForm'

enum Mode {
  STAKE = 'Stake',
  WITHDRAW = 'Withdraw',
}
interface Props {
  isOpen: boolean
  onClose: () => void
  deeprStaking: DeeprStakingI
}

const StakeModal = ({ isOpen, onClose, deeprStaking }: Props) => {
  const { t } = useTranslation('staking')

  const toggleValues = [
    { id: Mode.STAKE, name: t('modal.stake') },
    { id: Mode.WITHDRAW, name: t('modal.withdraw') },
  ]

  const { userStakingInfo } = deeprStaking

  const stakedAmount = parseFloat(formatUnits(userStakingInfo?.stakedAmount ?? 0, DEFAULT_DECIMALS))

  const hasAlreadyStaked = stakedAmount > 0

  const { activeMode, onToggleClick } = useLabelsToggle(toggleValues)

  useEffect(() => {
    if (!isOpen && activeMode === Mode.WITHDRAW) {
      onToggleClick()
    }
  }, [isOpen]) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered size={{ base: 'full', md: 'md' }}>
      <ModalOverlay />
      <ModalContent minW={{ base: 'auto', md: '480px' }}>
        <ModalHeader fontSize={{ base: '16px', md: '20px' }}>
          {t('modal.header')}
          <CloseModalButton />
        </ModalHeader>
        <ModalBody p={6}>
          {hasAlreadyStaked && (
            <Flex justifyContent="center" mb="6">
              <LabelsToggle onClick={onToggleClick} selected={activeMode} values={toggleValues} />
            </Flex>
          )}
          {activeMode === Mode.STAKE && (
            <StakeForm deeprStaking={deeprStaking} stakedAmount={stakedAmount} hasAlreadyStaked={hasAlreadyStaked} />
          )}
          {activeMode === Mode.WITHDRAW && <StakeWithdrawForm deeprStaking={deeprStaking} />}
        </ModalBody>
      </ModalContent>
    </Modal>
  )
}

export default StakeModal
